import {
  ADMIN_ROLE_VALUES,
  SUPERADMIN_ROLE_VALUES,
  UserRole,
} from '../constants/users.constants';

/**
 * True when the role grants admin-tier access (superadmin or admin).
 */
export const hasAdminAccess = (role?: UserRole | string | null): boolean =>
  role !== undefined && role !== null && ADMIN_ROLE_VALUES.includes(role as UserRole);

/**
 * True when the role is superadmin.
 */
export const hasSuperAdminAccess = (role?: UserRole | string | null): boolean =>
  role !== undefined && role !== null && SUPERADMIN_ROLE_VALUES.includes(role as UserRole);
